'use client';

import {useLocale} from 'next-intl';

export default function PrivacyCode() {
  const lang = useLocale();

  const html = {
    en: `
      <div id="otnotice-1788512a-6b6e-4f24-b2ea-af178658560a" className="otnotice"></div>
      <script src="https://privacyportal-eu-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js" type="text/javascript" charset="UTF-8" id="otprivacy-notice-script">
        settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC1ldS5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyJ9"
      </script>
      <script type="text/javascript" charset="UTF-8">
        OneTrust.NoticeApi.Initialized.then(function() {
          OneTrust.NoticeApi.LoadNotices(["https://privacyportal-eu-cdn.onetrust.com/d5013280-1479-402b-8f91-df8317c87c31/privacy-notices/1788512a-6b6e-4f24-b2ea-af178658560a.json"]);
        });
      </script>
    `,
    zh: `
      <div id="otnotice-8f87ba42-b312-4c5c-a711-092bfb7d7f70" class="otnotice"></div>
      <script src="https://privacyportal-eu-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js" type="text/javascript" charset="UTF-8" id="otprivacy-notice-script">
        settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC1ldS5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyJ9"
      </script>
      <script type="text/javascript" charset="UTF-8">
        OneTrust.NoticeApi.Initialized.then(function() {
          OneTrust.NoticeApi.LoadNotices(["https://privacyportal-eu-cdn.onetrust.com/d5013280-1479-402b-8f91-df8317c87c31/privacy-notices/8f87ba42-b312-4c5c-a711-092bfb7d7f70.json"]);
        });
      </script>
    `
  };
  return (
    <div dangerouslySetInnerHTML={{__html: html[lang] || html['en']}}></div>
  );
}
